import { render, staticRenderFns } from "./DialogUninstall.vue?vue&type=template&id=03adfd45&scoped=true&"
import script from "./DialogUninstall.vue?vue&type=script&lang=js&"
export * from "./DialogUninstall.vue?vue&type=script&lang=js&"
import style0 from "./DialogUninstall.vue?vue&type=style&index=0&id=03adfd45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03adfd45",
  null
  
)

export default component.exports